<template>
  <svg width="18"
       height="20"
       viewBox="0 0 18 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9063 10.1289L8.41113 16.6241C6.76758 18.2764 4.55274 18.1182 3.1377 16.6944C1.70508 15.2705 1.54688 13.0733 3.20801 11.4121L12.085 2.53519C13.0518 1.5684 14.4932 1.4014 15.4336 2.34183C16.374 3.29105 16.1982 4.72367 15.2314 5.68168L6.52149 14.4092C6.13477 14.8047 5.67774 14.6905 5.39649 14.4268C5.1416 14.1543 5.03613 13.6973 5.42285 13.3018L11.4961 7.22855C11.8037 6.91215 11.8213 6.45511 11.5225 6.15629C11.2236 5.87504 10.7666 5.88383 10.459 6.19144L4.35938 12.2911C3.41016 13.2403 3.44531 14.6905 4.28906 15.5342C5.20313 16.4483 6.58301 16.4219 7.53223 15.4727L16.2861 6.71C17.9912 5.01371 17.9297 2.7725 16.4355 1.27836C14.9678 -0.180627 12.6914 -0.286096 10.9863 1.41898L2.05664 10.3575C-0.166991 12.5899 -0.0175773 15.7891 2.0127 17.8194C4.03418 19.8321 7.24219 19.9903 9.46582 17.7666L16.0049 11.2364C16.3037 10.9375 16.3037 10.3926 15.9961 10.1114C15.7061 9.79496 15.2139 9.8389 14.9063 10.1289Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'ClipIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
